/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { FinnairOrder } from '../../models/finnair-order';

export interface GetOrderChanges$Params {
  orderId: string;
  orderChangeId: string;
  locale?: string;
  hash?: string;
}

export function getOrderChanges(http: HttpClient, rootUrl: string, params: GetOrderChanges$Params, context?: HttpContext): Observable<DapiHttpResponse<FinnairOrder>> {
  const rb = new DapiRequestBuilder(rootUrl, getOrderChanges.PATH, 'get');

  if (params) {
    rb.path('orderId', params.orderId, {});
    rb.path('orderChangeId', params.orderChangeId, {});
    rb.query('locale', params.locale, {});
    rb.query('hash', params.hash, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<FinnairOrder>;
    }),
    catchErrorAsJson()
  );
}

getOrderChanges.PATH = '/api/v2/order-change/{orderId}/{orderChangeId}';
